import { Lightbulb, ListChecks, FileCheck2, UserCog, AlertOctagon, Wrench } from "lucide-react";

const Block = ({ icon: Icon, title, children, testId }) => (
  <div className="rounded-md border border-slate-200 bg-white p-3" data-testid={testId}>
    <div className="mb-1.5 flex items-center gap-1.5 text-[11px] font-semibold uppercase tracking-wider text-slate-500"><Icon className="h-3.5 w-3.5 text-blue-600" />{title}</div>
    <div className="text-sm leading-relaxed text-slate-700">{children}</div>
  </div>
);

const List = ({ items }) => (items?.length ? <ul className="list-disc space-y-0.5 pl-4">{items.map((x) => <li key={x}>{x}</li>)}</ul> : <span className="text-slate-400">—</span>);

export const RequirementCard = ({ control: c }) => {
  const g = c.guidance || {};
  const rem = Object.entries(c.remediation || {}).filter(([, v]) => v).map(([k, v]) => `${k[0].toUpperCase()}${k.slice(1)}: ${v}`);
  return (
    <div className="grid gap-3 md:grid-cols-2" data-testid={`requirement-card-${c.id}`}>
      <Block icon={Lightbulb} title="What this means" testId="req-plain-language">{g.plain_language || c.why_it_matters}</Block>
      <Block icon={ListChecks} title="What the company needs to do" testId="req-what-to-do"><List items={g.what_to_do || [c.expected_state]} /></Block>
      <Block icon={FileCheck2} title="Evidence required" testId="req-evidence"><List items={c.evidence_required} /></Block>
      <Block icon={UserCog} title="Responsible owner" testId="req-owner">{g.owner_role || "Privacy / DPO"}</Block>
      <Block icon={AlertOctagon} title="Risk / impact" testId="req-risk">{g.risk_impact || c.why_it_matters}</Block>
      <Block icon={Wrench} title="Recommended remediation" testId="req-remediation"><List items={rem} /></Block>
      <p className="text-[11px] text-slate-400 md:col-span-2">Plain-language guidance is an aid to understanding — the official requirement text above prevails. Not legal advice.</p>
    </div>
  );
};
